<template>
  <div class="add">
    <el-dialog class="record-add" :title="title" width="1300px" :modal-append-to-body="false" :visible.sync="showAdd"
      @close="close">
      <el-form :inline="true"  ref="ruleForm" label-width="140px" label-position="right">
        <template v-for="item of forms">
          <el-form-item v-if="item.type === 'el-input'" :label="item.label" :required="item.required" :key="item.id" style="height:auto">
            <div v-if="item.prop === 'cooperation'" :style="item.style" :class="item.prop"
              class="el-input el-input--suffix" @click="onCooperation" placeholder="item.placeholder">
              <span class="el-input__inner" style="height:auto;min-height:40px">
                <span v-for="(i, idx) of cooperation_name" :key="i">
                  {{ i }}
                  <span v-if="idx < cooperation.length - 1">，</span>
                </span>
              </span>
            </div>
            <template v-else-if="item.prop === 'mobile'">
              <div class="phone" v-for="(i, idx) of item.default_val" :key="idx">
                <!-- :style="item.style" -->
                <el-input v-model="item.default_val[idx].tel" :placeholder="item.placeholder" style="width:330px !important;margin-right:20px;"
                  :clearable="item.clearable" @blur="onCheckTel(item.default_val[idx])"></el-input>
                <div class="btn-box">
                    <el-button  class="add-btn" :disabled="nolength" :style="{ display: idx == 0 ? 'true' : '' }"  icon="el-icon-minus"
                  @click="delPhone(item.default_val, idx)"></el-button>
                  <span></span>
                  <!-- v-if="idx == item.default_val.length - 1" -->
                    <el-button class="add-btn" icon="el-icon-plus"
                  @click="addPhone(item.default_val)"></el-button>
                </div>


                <p v-if="item.default_val[idx].code == 99" style="color: #f56c6c; margin-left: 20px">
                  <i class="el-icon-error" style="margin-right: 4px"></i>
                  <span>{{ item.default_val[idx].errorMsg }}</span>
                </p>
                <p v-if="item.default_val[idx].code == 1" style="color: #67c23a; margin-left: 20px">
                  <i class="el-icon-success" style="margin-right: 4px"></i>
                  <span>{{ item.default_val[idx].errorMsg }}</span>
                </p>
              </div>
            </template>
            <el-input v-else v-model="item.default_val" :placeholder="item.placeholder" :style="item.style"
              :clearable="item.clearable"></el-input>
          </el-form-item>

          <el-form-item v-if="item.type === 'el-selecte'" :label="item.label" :required="item.required" :key="item.id">
            <el-select style="width:450px" v-model="item.default_val" :placeholder="item.placeholder" :clearable="item.clearable">
              <el-option v-for="i in item.options" :key="i.id" :label="i.text" :value="i.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="item.type === 'el-date-picker'" :label="item.label" :required="item.required"
            :key="item.id">
            <el-date-picker v-model="item.default_val" type="date" :placeholder="item.placeholder"
              :clearable="item.clearable" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </template>
      </el-form>
      <el-divider></el-divider>
      <form-create v-model="yulanform" :rule="formrule" :option="option" @on-submit="onSubmit1"
        style="width: 80%;margin-top: 20px;"></form-create>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="lockSave" @click="formSubmit">保存</el-button>
        <el-button class="btn-big" type="primary"  :loading="lockAdd" @click="addContact">添加联系人</el-button>
      </div>
    </el-dialog>
    <contact ref="ContactAdd" type="customer" :id="customer_id"></contact>
    <mail-list ref="drawer" checkbox :module="module" :userid="this.$store.state.user.token.userid"
      @handleSelect="handleSelect"></mail-list>
  </div>
</template>
<script>
import contact from "@/components/Contact/add";
import mailList from '@/components/drawer/mailList';
import { addCustomer } from "@/api/customer";
import { getFieldConfigs } from "@/api/user";
import { checkPhone } from "@/api/common";
export default {
  name: "customerAdd",
  inject: ["reload"],
  components: {
    contact,
    mailList
  },
  props: {
    customerData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      title: "新增客户",
      showAdd: false,
      module: "",
      btn: "",
      userid: this.$store.state.user.token.userid,
      customer_id: 0,
      cooperation: [],
      cooperation_name: [],
      forms: [],
      lockSave: false,
      lockAdd: false,
      yulanform: "",
      formrule: [],
      option: {
        submitBtn: {
          show: false,
        },
      },
      fie: [],
      custom_field: {}
    };
  },
  mounted() {
    this.getField()
  },
  computed:{
    nolength() {
      let i
      this.forms.map((item, index) => {
        if (item.label === '联系电话') {
          i = index
        }
      })
      let a
      if(this.forms[i].default_val.length==1){
        a = true
      }
      return a;
    }
  },
  methods: {
    async onCheckTel(obj) {
      try {
        const res = await checkPhone({
          account_id: this.$store.state.user.token.account_id,
          remark_mobiles: obj.tel,
        });
        obj.errorMsg = res.msg;
        obj.code = res.code;
      } catch (error) {
        console.log(error);
      }
    },
    async getConfigs() {
      const res = await getFieldConfigs({
        account_id: this.$store.state.user.token.account_id,
        types: "customer",
      });
      const data = res.data;
      data.filter((item) => {
        if (item.prop === "mobile") {
          item.default_val = [
            {
              tel: "",
              errorMsg: "",
              code: 0,
            },
          ];
        }
        if (item.prop === "cooperation") {
          console.log(this.cooperation)
          item.default_val = this.cooperation;
        }
      });
      this.forms = res.data;
      console.log(this.forms)
    },
    verifyMobiles() { },
    async onSave() {
      let data = {};
      let telArray = [];
      let arr = JSON.parse(JSON.stringify(this.forms))
      for (const item of arr) {
        if(item.prop === 'up_date'){
          item.default_val=item.default_val.substring(0,10)
        }
        if (item.required) {

          if (!item.default_val) {
            // 以下判断是因为性别选择增加了未知项，而它的值为 0 ，所以需要判断
            if (item.default_val === 0) {
              item.default_val = 0;
            } else {
              this.$message.error(`${item.label}不能为空！`);
              return;
            }
          }
        }
        if (item.prop === "mobile") {
          telArray = item.default_val;
          item.default_val = item.default_val.map((m) => m.tel);
        }
        Reflect.set(data, item.prop, item.default_val);
        Reflect.set(data, "cooperation", this.cooperation);
      }
      let selfSub = {}
      for (let i in this.custom_field) {
        this.fie.push(i)
      }
      for (let i = 0; i < this.fie.length; i++) {
        for (let j = 0; j < this.formrule.length; j++) {
          if (this.formrule[j].field == this.fie[i]) {
            this.$set(selfSub, this.fie[i], this.formrule[j])
          }
        }
      }
      Reflect.set(data, "account_id", this.$store.state.user.token.account_id);
      Reflect.set(data, "userid", this.$store.state.user.token.userid);
      Reflect.set(data, "self_content", JSON.stringify(selfSub));
      if (this.btn === "submit") {
        this.lockSave = true;
      } else {
        this.lockAdd = true;
      }

      if (Object.keys(this.customerData).length !== 0) {
        Reflect.set(data, "userid", this.customerData.owner);
        Reflect.set(data, "leads_id", this.customerData.id);
        Reflect.set(data, "leads_pasttime", this.customerData.leads_pasttime);
        Reflect.set(data, "external_userid", this.customerData.external_userid);
        // 线索转化客户
        const res = await addCustomer(data);
        if (res.code == 1) {
          if (this.btn === "submit") {
            this.$router.push({
              name: "customer",
            });
          } else {
            this.customer_id = res.data.customer_id;
            this.showAdd = false;
            this.$refs.ContactAdd.open();
          }
        }
        for (const item of this.forms) {
          // 此处是为了把手机数组重新改为前端可用的数组，方便手机号验证错误信息的展示
          if (item.prop === "mobile") {
            item.default_val = telArray;
          }
        }
        this.lockSave = false;
        this.lockAdd = false;
        return;
      }
      // 添加客户
      const res = await addCustomer(data);
      if (res.code === 1) {
        if (this.btn === "submit") {
          this.reload();
        } else {
          this.customer_id = res.data.customer_id;
          this.showAdd = false;
          this.$refs.ContactAdd.open();
          this.$emit("refresh");
        }
      }

      this.lockSave = false;
      this.lockAdd = false;
      for (const item of this.forms) {
        // 此处是为了把手机数组重新改为前端可用的数组，方便手机号验证错误信息的展示
        if (item.prop === "mobile") {
          item.default_val = telArray;
        }
      }
    },
    handleSelect(person) {
      let cooperation = []; //协助者ID
      let cooperation_name = [];
      person.map((item) => {
        cooperation.push(item.userid);
        cooperation_name.push(item.name);
      });

      this.cooperation = cooperation;
      this.cooperation_name = cooperation_name;
      console.log(this.cooperation)
    },
    onCooperation() {
      this.module = "helper";
      this.$refs.drawer.open();
    },
    addPhone(item) {
      item.push({
        tel: "",
        errorMsg: "",
        code: 0,
      });
    },
    delPhone(arr, index) {
      if (arr.length === 1) {
        arr[0] = {
          tel: "",
          errorMsg: "",
          code: 0,
        };
        arr.push();
        return;
      }
      arr.splice(index, 1);
    },
    async open() {
      this.showAdd = true;
      this.getField();
      await this.getConfigs();
      this.userid = this.$store.state.user.token.userid;
      // 线索转化客户
      if (Object.keys(this.customerData).length !== 0) {
        console.log(123)
        this.title = "转化为客户";
        for (const item of this.forms) {
          if (item.prop === "customer_level_id") {
            continue;
          }
          if (item.prop === "mobile") {
            Reflect.set(
              item,
              "default_val",
              this.customerData["remark_mobiles"]
            );
            continue;
          }
          if (item.prop === "cooperation") {
            Reflect.set(
              item,
              "default_val",
              this.cooperation
            );
            continue;
          }
          Reflect.set(item, "default_val", this.customerData[item.prop]);
        }
      }
    },
    close() {
      this.showAdd = false;
    },
    formSubmit() {
      this.btn = "submit";
      this.onSave();
    },
    addContact() {
      this.btn = "addContact";
      this.onSave();
    },
    async getField() {
      const res = await this.axios({
        url: "/crm/ApplyExpense/get_custom_filed",
        method: "POST",
        data: {
          account_id: this.$store.state.user.token.account_id,
          state: "customer"
        }
      })
      if (res.code == 1) {
        this.custom_field = res.data.custom_field
        let arr = []
        this.formrule = []
        for (let i in this.custom_field) {
          arr.push(this.custom_field[i])
        }
        arr.forEach(item => {
          if (!item.if_show) {
            item.display = item.if_show
          }
          this.formrule = arr;
        })
      }
    },
    onSubmit1(formData) {
      alert(JSON.stringify(formData));
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  display: flex;
  justify-content: flex-end;

  margin-top: 60px;
  display: flex;
  justify-content: center;
}

::v-deep .cooperation input {
  cursor: pointer;
}
.btn-box{
  border-radius: 20px;
  width: 100px;
  border: 0px ;
  height: 100%;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;

}
.btn-box>span{
    height: 25px;
    background: #e6e6e6;
    width: 1px;
}
.add-btn {
  margin-left: 0px;
  margin-right:0px;
  height: 100%;
  width: 50% !important;
  border: none;
  background: none;
}

.phone {
  margin-top: 12px;
  display: flex;
}

.phone:nth-child(1) {
  margin-top: 6px;
}


.el-form-item{
  width:50%;
}
::v-deep .el-form--inline .el-form-item{
  margin-right: 0px;
  margin-bottom: 30px;
}
.el-divider{
  height: 5px;
  margin: 10px 0;
}

.el-input{
  width:450px !important;
}
.el-input__inner{
  border-color: #e6e6e6;
  border-radius: 8px;

}

</style>
